export default {
	projectName: "Insights Live",
	authorizing: "Authorizing...",
	"log-out": "Log out",
	"change-theme": "Change theme",
	features: {
		deviations: "Deviations",
		logs: "Logs",
		activities: "Activities",
		sites: "Sites",
		realtime: "Realtime",
		home: "Home",
		settings: "Settings",
		preferences: "Preferences",
		admin: "Admin",
		metrics: "Metrics",
	},
	noAccess: {
		title: "No access",
		message: "You do not have access to any company. Please contact your administrator.",
	},
	error: {
		title: "Something went wrong",
		message:
			"This means we have an issue that is hard to locate. Clear your cache and local storage may help",
		navDescription: "If it still doesn't work contact our support",
		numberText: "+47 488 52 488",
		emailText: "support.digital@scaleaq.com",
		refreshText: "Refresh",
	},
	notFound: {
		title: "Page not found",
		message:
			"The page you are looking for does not exist. Please check the URL or return to the homepage.",
		navDescription: "If it still doesn't work contact our support",
		refreshText: "Refresh",
		numberText: "+47 488 52 488",
		emailText: "support.digital@scaleaq.com",
	},
	custom: "Egendefinert",
	time: {
		"add-time": "Add time",
		"select-date-range": "Select date range",
		time: "Time",

		"last-7-days": "Last 7 days",
		"last-31-days": "Last 31 days",
		"this-month": "This month",
		"this-year": "This year",
		today: "Today",
		"next-7-days": "Next 7 days",
		"next-31-days": "Next 31 days",
		timeframe: "Timeframe",
		"6hours": "6 timer",
		"12hours": "12 timer",
		"24hours": "24 timer",
		"7days": "7 dager",
	},
	dataType: {
		water_oxygen_percentage: "Oxygen",
		water_oxygen_umol: "Oxygen",
		water_oxygen_mg_l: "Oxygen",
		water_temperature: "Water Temperature",
		water_salinity: "Salinity",
		sensor_depth: "Depth",
		Appetite: "Appetite",
		Biomass: "Biomass",
		Dose: "Dose",
		FeedAmount: "Feed Amount",
		FishWeight: "Fish Weight",
		HandFeedWeight: "Hand Feed Weight",
		Intensity: "Intensity",
		Loadcell: "Loadcell",
		ManualAmount: "Manual Amount",
		Mean: "Mean",
		PelletCount: "Pellet Count",
		PelletFishMinute: "Pellet Fish Minute",
		Planned: "Planned",
		Recommended: "Recommended",
		SFR: "SFR",
		SGR: "SGR",
		StandardAppetite: "Standard Appetite",
		Target: "Target",
		TodayAppetite: "Today Appetite",
		TotalFeedWeight: "Total Feed Weight",
		avgWeight: "Average Weight",
		blowerSpeed: "Blower Speed",
		compass: "Compass",
		conductivity: "Conductivity",
		fcr: "FCR",
		feedStoreAmount: "Feed Store Amount",
		humidity: "Humidity",
		latitude: "Latitude",
		longitude: "Longitude",
		pellet_count: "Pellet Count",
		pressure: "Pressure",
		pressurePipe: "Pressure Pipe",
		recommendedFeedWeight: "Recommended Feed Weight",
		runtime: "Runtime",
		sal_conductivity: "Salinity Conductivity",
		sal_density: "Salinity Density",
		sal_sound_speed: "Salinity Sound Speed",
		sal_temp: "Salinity Temperature",
		saturation: "Saturation",
		sc_abs_tilt: "Sea Current Absolute Tilt",
		sc_heading: "Sea Current Heading",
		sc_max_tilt: "Sea Current Max Tilt",
		sc_sp_standard: "Sea Current Speed Standard",
		sc_std_tilt: "Sea Current Standard Tilt",
		sc_strength: "Sea Current Strength",
		sc_tilt_x: "Sea Current Tilt X",
		sc_tilt_y: "Sea Current Tilt Y",
		sea_current_absolute_speed: "Sea Current Speed",
		sea_current_direction: "Sea Current Direction",
		sea_current_east: "Sea Current East",
		sea_current_north: "Sea Current North",
		sgr: "SGR",
		smartSpreaderCycleTime: "Smart Spreader Cycle Time",
		smartSpreaderCyclicMax: "Smart Spreader Cyclic Max",
		smartSpreaderCyclicMin: "Smart Spreader Cyclic Min",
		smartSpreaderManualSpeed: "Smart Spreader Manual Speed",
		targetRecommended: "Target Recommended",
		temperatureFeedingLine: "Temperature Feeding Line",
		wind_direction: "Wind Direction",
		wind_speed: "Wind Speed",
	},
	buttons: {
		back: "Back",
	},
};
